import { useEffect, useRef } from 'react';

import './NavbarApp.css';

import { NavLink } from 'react-router-dom';
import { RxHamburgerMenu } from 'react-icons/rx';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';

export default function NavbarApp(props: any) {
  useEffect(() => {

  }, []);

  return (
    <>
      <Navbar expand='lg' className='navbarapp'>
        <Container className='bg-appprimary' fluid>
          <Navbar.Brand className=''>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarAppContent">
            <RxHamburgerMenu className='navItem-icon' />
          </Navbar.Toggle>
          <Navbar.Collapse id="navbarAppContent" >
            <Nav className='navbar-main'>
              <NavLink to="/zero-trust" className='navApp-item'>
                <h3 className='navItem-icon'>ZT</h3>
                {/* <div className='navItem-text'>Zero Trust</div> */}
              </NavLink>
              <div className='navApp-item' style={{ pointerEvents: 'none' }} >
                An interactive dashboard for exploring DOD's phased approach to Zero Trust.
              </div>
            </Nav>

          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  )
};
